import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./DSIProductTour.module.css";
import FilterHeader from "./components/FilterHeader";
import { useApi } from "../../../../common/hooks";
import ProductTourHeader from "./components/ProductTourHeader";
import ProductTourRow from "./components/ProductTourRow";
import ProductTourAttributionSidePanel from "./components/assign-side-panel/ProductTourAttributionSidePanel";
import { isNonEmptyArray } from "../../../../common/utils";
import productTourManagementService from "../../../../api/services/back-office/product-tour-management-service";

const dedupeByName = (arr) => {
	const map = new Map();
	arr.forEach((item) => map.set(item.name, item));
	return Array.from(map.values());
};
export default function DSIProductTour({ companies }) {
	const [ptName, setPtName] = useState("");
	const [openSidePanel, setOpenSidePanel] = useState(false);
	const [productTours, setProductTours] = useState([]);
	const [temporaryProductTours, setTemporaryProductTours] = useState([]);
	const [selectedProductTours, setSelectedProductTours] = useState([]);
	const [checkedAll, setCheckedAll] = useState(false);
	const [checkedPt, setCheckedPt] = useState([]);
	const { call: getAllProductTours } = useApi(productTourManagementService.getAllProductTours);
	const { call: updateProductTourList } = useApi(productTourManagementService.updateProductTourList);
	const checkedInCurrentFilteredPts = useMemo(
		() => checkedPt.filter((chkd) => temporaryProductTours.some((fchkd) => fchkd.name === chkd.name)),
		[checkedPt, temporaryProductTours]
	);
	const sortedDisplayTemporaryProductTours = useMemo(() => {
		if (!temporaryProductTours) {
			return [];
		}
		return [...temporaryProductTours].sort((a, b) => a.name?.localeCompare(b.name));
	}, [temporaryProductTours]);
	useEffect(() => {
		getAllProductTours()
			.then((data) => {
				if (!isNonEmptyArray(data)) {
					updateProductTourList([
						{ id: null, name: "DOCUMENTS" },
						{ id: null, name: "SEARCH" },
						{ id: null, name: "MY_REVIEW_NAV_COM" },
					]);
					window.location.reload();
				}
				setProductTours(data);
				setTemporaryProductTours(data);
			})
			.catch((err) => console.error(err));
	}, [getAllProductTours, updateProductTourList]);
	useEffect(() => {
		setTemporaryProductTours(
			(ptName.length === 0 && productTours) ||
				productTours.filter((pt) => pt?.name?.toLowerCase()?.includes(ptName?.toLowerCase()))
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ptName, productTours]);
	const handleChangeFilters = useCallback(({ name }) => {
		setPtName(name);
	}, []);
	const handleCheckAll = () => {
		if (checkedInCurrentFilteredPts.length < temporaryProductTours.length) {
			setCheckedAll(true);
			setCheckedPt((prev) => dedupeByName([...prev, ...temporaryProductTours]));
		} else {
			setCheckedAll(false);
			setCheckedPt((prev) =>
				prev.filter((chkd) => !temporaryProductTours.some((fchkd) => fchkd.name === chkd.name))
			);
		}
	};
	const handleCheckPt = (cmp) => {
		if (checkedInCurrentFilteredPts.some((cpt) => cpt.name === cmp.name)) {
			if (checkedInCurrentFilteredPts.length === 1) {
				setCheckedAll(false);
			}
			setCheckedPt((prev) => prev.filter((cpt) => cpt.name !== cmp.name));
		} else {
			if (checkedInCurrentFilteredPts.length === temporaryProductTours.length - 1) {
				setCheckedAll(true);
			}
			setCheckedPt((prev) => [...prev, cmp]);
		}
	};
	const handleClose = () => {
		setOpenSidePanel((prev) => !prev);
	};
	const handleSelectRow = (pt) => {
		setSelectedProductTours((isNonEmptyArray(pt) && pt) || [pt]);
		handleClose();
	};
	const handleOpenAssign = () => {
		handleSelectRow(checkedPt);
	};
	const handleSave = (productTourId, numberOfCompanies) => {
		if (!isNonEmptyArray(productTourId)) {
			setProductTours((prev) =>
				prev.map((pt) => (pt.id === productTourId ? { ...pt, companies: numberOfCompanies } : pt))
			);
		}
	};
	return (
		<div className={styles.container}>
			<FilterHeader onChangeFilters={handleChangeFilters} />
			<ProductTourHeader
				checkedAll={checkedAll}
				countChecked={checkedPt.length}
				currentCheckedList={checkedInCurrentFilteredPts}
				currentList={temporaryProductTours}
				onCheckAll={handleCheckAll}
				onOpenAssign={handleOpenAssign}
			/>
			<div className={styles.list}>
				{sortedDisplayTemporaryProductTours.map((tpt) => (
					<ProductTourRow
						key={tpt.id}
						checkedPt={checkedPt}
						tpt={tpt}
						onCheck={handleCheckPt}
						onSelectRow={handleSelectRow}
					/>
				))}
			</div>
			<ProductTourAttributionSidePanel
				companies={companies}
				open={openSidePanel}
				selectedProductTours={selectedProductTours}
				onClose={handleClose}
				onSave={handleSave}
			/>
		</div>
	);
}
